import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useGurus(stockId, hubGurus) {
  const skipFetch = hubGurus !== undefined
  const { data, error, isLoading } = useSWRImmutable(
    skipFetch ? null : `/react/gurus?stock_id=${stockId}`,
    fetcher,
  )

  return {
    gurus: skipFetch ? hubGurus : data,
    isLoading: skipFetch ? false : isLoading,
    error: skipFetch ? undefined : error,
  }
}